@use "../../styles/breakpoint" as *;

.root {
    background-color: var(--black);
    color: var(--white);
    padding: 54px 0;
}

.header {
    composes: container from "../../styles/composable/layout.module.css";
    margin-bottom: 32px;
}

.carousel {
    composes: container from "../../styles/composable/layout.module.css";
}

.wrapper {
    align-items: center;
    display: grid;
    grid-template-columns: 44px 1fr 44px;
    gap: 44px;

    @media ($below-mobile) {
        grid-template-columns: 1fr;
        padding: 0 var(--container-margin);
    }
}

.slide {
    align-items: center;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;

    @media ($below-mobile) {
        grid-template-columns: 1fr;
    }
}

.button {
    background-color: rgb(var(--white-base) / 75%);
    border: none;
    border-radius: 50%;
    height: 44px;
    width: 44px;

    &:disabled {
        opacity: 0.5;
    }
}

.buttonIcon {
    height: 26px;
    position: relative;
    top: 2px;
    width: 26px;
}

.dots {
    display: flex;
    gap: 4px;
    justify-content: center;
    margin-top: 36px;
    padding: 16px 0;

    & > button {
        appearance: none;
        background-color: transparent;
        border: 2px solid var(--white);
        border-radius: 50%;
        height: 20px;
        width: 20px;

        &:disabled {
            background-color: var(--white);
        }
    }
}
